import React, { useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import useRoomForm from "../../../../hooks/useRoomForm";
import TextField from "../../../../../ui/TextField";
import DataSelect from "../../../../../ui/DataSelect";
import WorldSkillDataSelect from "../../../../../ui/DataSelect/WorldSkillDataSelect";
import SpecialitiesDataSelect from "../../../../../ui/DataSelect/SpecialitiesDataSelect";
import SpecialitiesCards from "../../../../../ui/SpecialitiesCards";
import Checkbox from "../../../../../ui/Checkbox";
import Chips from "../../../../../ui/Chips";

const defaultData = {
  name: "",
  buildingId: null,
  roomType: null,
  depId: null,
  area: null,
  capacity: null,
  number: "",
  note: "",
  demo: false,
  limiting: "",
  specialities: [],
  worldSkills: []
};

const styles = () => ({
  root: {
    maxWidth: 774,
    minWidth: 400,
    marginLeft: 8,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    },
    "& .MuiGrid-spacing-xs-4 > .MuiGrid-item": {
      paddingTop: 4,
      paddingBottom: 5
    }
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  mainGrid:{
    marginTop: 8
  },
  block: {
    margin: "35px 0 15px 0"
  },
});

const RoomInfoForm = ({ disabled, onFormChange, initialData, classes, editmode }) => {
  const [data, setData] = React.useState(initialData || defaultData);
  const { dataSources, getRoomDeparments, getRoomForm } = useRoomForm();
  const {
    name,
    buildingId,
    roomType,
    depId,
    area,
    capacity,
    number,
    note,
    limiting,
    specialities,
    worldSkills,
    demo,
  } = data;

  useEffect(() => {
    getRoomForm();
  }, []);

  useEffect(() => {
    buildingId && getRoomDeparments(buildingId);
  }, [buildingId]);

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
    onFormChange(newState);
  };

  return (
    <div className={classes.root}>
      <Typography className={classes.heading}>Общие сведения</Typography>
      <Grid container spacing={4}  className={classes.mainGrid}>
        <Grid item xs={12}>
          <TextField
            required
            value={name}
            onChange={e => onChange("name", e.target.value)}
            label="Название"
            disabled={disabled}
            readOnly={!editmode}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            required
            value={number}
            onChange={e => onChange("number", e.target.value)}
            label="Номер"
            disabled={disabled}
            readOnly={!editmode}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <DataSelect
            value={roomType}
            onChange={value => onChange("roomType", value.id)}
            label="Тип"
            dataSource={dataSources.roomTypes}
            disabled={disabled}
            readOnly={!editmode}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            value={area}
            onChange={e => onChange("area", e.target.value)}
            label="Площадь (м2)"
            disabled={disabled}
            readOnly={!editmode}
          />
        </Grid>
        <Grid item xs={12}md={3}>
          <TextField
            value={capacity}
            onChange={e => onChange("capacity", e.target.value)}
            label="Вместимость"
            disabled={disabled}
            readOnly={!editmode}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <DataSelect
            value={buildingId}
            onChange={value => onChange("buildingId", value.id)}
            label="Адрес"
            dataSource={dataSources.facilities}
            getOptionLabel={option => option.orgName ? `${option.address} (${option.orgName})` : `${option.address}`}
            disabled={disabled}
            readOnly={!editmode}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <DataSelect
            value={depId}
            onChange={value => onChange("depId", value.id)}
            label="Подразделение"
            dataSource={dataSources.departments}
            disabled={disabled}
            readOnly={!editmode}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            value={note}
            onChange={e => onChange("note", e.target.value)}
            label="Описание"
            disabled={disabled}
            readOnly={!editmode}
          />
          <TextField
            value={limiting}
            onChange={e => onChange("limiting", e.target.value)}
            label="Ограничения доступности"
            disabled={disabled}
            readOnly={!editmode}
          />
          </Grid>
        </Grid>
      <div className={classes.block}>
        <Checkbox
          label="Оборудовано для проведения демо-экзамена"
          checked={demo}
          handleChange={(_, val) => onChange("demo", val)}
          disabled={!editmode}
        />
      </div>
      {(specialities.length!==0 || editmode) && (<div className={classes.block}>
        <Typography className={classes.heading}>
          Специальности и профессии, для которых оборудован кабинет
        </Typography>
      </div>)}

      {(disabled || !editmode) ? (
        <SpecialitiesCards specialities={specialities} />
      ) : (
        <SpecialitiesDataSelect
          value={specialities}
          label=""
          dataSource={dataSources.specialities}
          disabled={disabled}
          onChange={value => onChange("specialities", value)}
        />
      )}
      {(worldSkills.length!==0 || editmode) && (<div className={classes.block}>
        <Typography className={classes.heading}>Компетенции</Typography>
      </div>)}
      {(disabled || !editmode) ? (
        <Chips worldSkills={worldSkills} largeWS={true}/>
      ) : (
        <WorldSkillDataSelect
          value={worldSkills}
          label=""
          dataSource={dataSources.worldSkills}
          disabled={disabled}
          onChange={value => onChange("worldSkills", value)}
        />
      )}
    </div>
  );
};

export default withStyles(styles)(RoomInfoForm);
